import { Component } from '@angular/core';

@Component({
  selector: 'app-inline-loader',
  templateUrl: './inline-loader.component.html',
})
export class InlineLoaderComponent {}
